var $ = require('jquery');
import inview from 'jquery-inview/jquery.inview';
import lazyLoad from 'vanilla-lazyload/dist/lazyload';
import Headroom from 'headroom.js';
import Glider from "glider-js";


let clickEvent = '';
if ('ontouchstart' in window) {
	clickEvent = 'touchstart';
} else {
	clickEvent = 'click tap';
}

$(document).ready(function () {
	initInviewAnimate();
	initHeadroom();
	initLazyLoad();
	handleHeaderMenuToggling();
	initMobileDrawer();
	handleSiteMargin();
	handleDropdownToggling()
	closeHeaderMenu()
});

$(window).on('scroll', function () {
	initInviewWidthOffset();
});

$(document).on('resize', function () {
	initInviewWidthOffset();
});

$(window).on('load', function () {
	preLoader();
	showBelowFold();
	initInviewWidthOffset();
});


function preLoader() {
	$("body .preloader").fadeOut();
}

function showBelowFold() {
	$('section.section').css('display', 'block');
}

function initHeadroom() {
	var headerElements = document.getElementsByClassName("site-header"),
		headerElementsNo = headerElements.length;

	if (headerElementsNo > 0) {
		for (var i = 0; i < headerElementsNo; i++) {
			var headroom = new Headroom(headerElements[i]);
			headroom.init();
		}
	}
}

function initLazyLoad() {
	const lazy = new lazyLoad({
		elements_selector: '.lazy',
		load_delay: 300
	});

	let variableSrc = 'src-desktop';
	if ($(window).width() < 768) {
		variableSrc = 'src-mobile';
	}

	const bgLazy = new lazyLoad({
		elements_selector: '.lazy-bg',
		data_bg: variableSrc,
		load_delay: 300
	});

	const imgLazy = new lazyLoad({
		elements_selector: '.lazy-img',
		data_src: variableSrc,
		load_delay: 300
	});

	let heroLazy = new lazyLoad({
		elements_selector: '.lazy-hero',
		data_bg: variableSrc,
		load_delay: 0
	});

	heroLazy.loadAll();
}

function initInviewAnimate() {
	var inviewElements = $(".inview-animate--fade")
		.add(".inview-animate--move-up")
		.add(".inview-animate--move-down")
		.add(".inview-animate--move-left")
		.add(".inview-animate--move-right")
		.add(".inview-animate--scale");

	inviewElements.each(function () {
		var thisInviewElement = $(this);

		thisInviewElement.bind('inview', function (event, visible) {
			if (visible == true) {
				thisInviewElement.addClass('inview-active');
			}
		});
	});
}

function initInviewWidthOffset() {
	document.querySelectorAll('.inview-offset:not(.inview-active)').forEach(function (item) {
		if (inBoundries(item)) {
			item.classList.add('inview-active');
		}
	});
}
function inBoundries(el) {
	var container = $(window);
	const top = el.offsetTop;
	return (top < (container.scrollTop() + window.innerHeight - 200));
}

function handleDropdownToggling() {
	const dropdownParents = $('.site-header__nav .menu .menu-item.menu-item-has-children')
	dropdownParents.each((index, item) => {
		const aTagInnerHtml = $(item).find('a').html();
		const aTagHref = $(item).find('a').attr('href');
		const divElem = `<div><a href=${aTagHref}>${aTagInnerHtml}</a><span class="arrow"></span></div>`
		$(item).children('a').remove()
		$(item).html(divElem + $(item).html())
	})

	$('.site-header__nav .menu .menu-item.menu-item-has-children .arrow').on('click', function (e) {
		$(this).parent('div').parent('.menu-item ').toggleClass('open')
	})
}

function closeHeaderMenu() {
	const headerMenu = $(".site-header__nav");
	const headerBurger = $(".site-header__mobile-trigger");

	$(".site-header .menu-item .sub-menu .menu-item").on('click', function () {
		$('body').removeClass('noscroll');
		headerBurger.removeClass("active");
		headerMenu.removeClass("active");
		$('html').removeClass('noscroll');
		$('.site-header .menu .menu-item').removeClass('open')
	})
}

function handleHeaderMenuToggling() {
	var header = $(".site-header"),
		headerMenu = $(".site-header__nav-wrap"),
		headerBurger = $(".site-header__nav-trigger, .site-drawer__menu-toggle-close");

	if (headerMenu.length) {
		headerBurger.on("click", function () {
			var index = 0;

			$('body').toggleClass('noscroll');
			$(this).toggleClass("active");
			headerMenu.toggleClass("menu-active menu-closed");
			header.toggleClass("nav-active");
		});
	}
}

function initMobileDrawer() {
	$('.site-header__mobile-trigger a').on('click', function (e) {
		e.preventDefault();
		$('.site-header__nav').toggleClass('active');
		$('.site-header__mobile-trigger').toggleClass('active');
		$('body, html').toggleClass('noscroll');
	});
}

function handleSiteMargin() {
	let headerHeight = $('header').outerHeight();
	$('.site-inner').css('margin-top', headerHeight);
}

$('.scroll-to-section').on('click', function (e) {
	e.preventDefault();
	const urlArr = $(this).attr('href').split('#') ?? []
	const id = urlArr[urlArr.length - 1]
	const section = $(`#${id}`);
	if (section) {
		let elementPosition = section[0].getBoundingClientRect().top;
		let offsetPosition = elementPosition + window.scrollY - 80;
		window.scrollTo({
			top: offsetPosition,
			behavior: "smooth"
		});
	}
})


new Glider(document.querySelector('.testimonials-slider'), {
	slidesToShow: 1,
	slidesToScroll: 1,
	draggable: true,
	dots: '.dots',
	arrows: false,
	responsive: [
		{
			breakpoint: 767,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1
			}
		}, {
			breakpoint: 1024,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 1
			}
		}
	]
});

$(window).on('resize', () => {
	dotCheck()
})
$(window).on('load', () => {
	dotCheck()
})

function dotCheck() {
	const totalTots = $('.section-testimonial .dots button')
	if (totalTots.length === 1) {
		$('.section-testimonial .dots').addClass('no-dots')
	} else {
		$('.section-testimonial .dots').removeClass('no-dots')
	}
}